import { RESULT_FL } from '@/config/display/basic.config'
// m 转 km
const km = value => {
  if (+value > 0) return (value / 1000).toFixed(2)
  return 0
}

// 经理状态转换
const dmTaskStatus = value => {
  let statusText = null
  switch (+value) {
    case 1:
    case 4:
      statusText = '不合格'
      break
    case 2:
      statusText = '合格'
      break
    case 3:
      statusText = '无展示'
      break
  }
  return statusText
}

// 最终结果状态
const finalStatus = value => {
  let statusText = null
  switch(+value) {
    case 1:
      statusText = '合格'
      break
    case 2:
      statusText = '不合格'
      break
    case 3:
      statusText = '无展示'
      break
    case 4:
      statusText = '无结论'
      break
    default:
      statusText = '无数据'
  }
  return statusText
}

// 初查&复查 状态号 转 状态名
const flCheckRusultStatus = value => {
  const hit = RESULT_FL.find(v => +v.value === +value)
  if (hit) return hit.label
  return null
}



export default {
  km,
  dmTaskStatus,
  finalStatus,
  flCheckRusultStatus
}
